module.exports = __webpack_public_path__ + "img/gameTronos.8dca85b8.jpg";